import React, { useEffect, useState } from "react";
import GalleryReviews from '../../Data/Admin/GalleryReviews.json';
import { Link} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faXmark, faPenToSquare, faEye} from '@fortawesome/free-solid-svg-icons';
import { getEventGallery, getEventGalleryById, deleteEventGallery } from '../../Service';
import Swal from "sweetalert2";

export default function GalleryReview(){

    const [perPage, setPerPage] = useState(100);
    const [curPage, setCurPage] = useState(1);
    const [list, setList] = useState([]);
    const [currentItems, setCurrentItems] = useState([]);

    useEffect(() => {
        getEventGallery().then(res => handleResponse(res))
    }, [curPage]);

    const handleResponse = (response) => {
    setList(response.data.data.event.items);
    }

    const handleEyeClick =(getid) => {
        let review_id=getid;
        let params={review_id:getid};
        getEventGalleryById(params).then(res => handleProgramResponse(res))
      }
  
      const handleProgramResponse = (response) => {
  console.log('log 34', response.data.data.image_path)
          Swal.fire({
              title: '<strong>'+response.data.data.title+'</strong>',
              html:
              'Date : '+response.data.data.date +'</br> ' +
              'Author : '+response.data.data.author+'</br> ' +
              'City : '+response.data.data.city+'</br> ' +
              'Country : '+response.data.data.country+'</br> ' +
              'Address: '+response.data.data.address+'</br> ' +
              'Address 2: '+response.data.data.address_2+'</br> ' +
              'Description: '+response.data.data.description+'</br> ' +
              'Gallery name: '+response.data.data.gallery_name+'</br> ' +
              'review: '+response.data.data.review+'</br> ' +
              'Website: '+response.data.data.website+'</br> ' +
              
                '',
              imageUrl: response.data.data.image_path.replace('http://localhost/storage/','https://dev.datanetiix.com/photola_api/storage/app/public/'),
              showCloseButton: true,
              //showCancelButton: true,
              //focusConfirm: false,
              //confirmButtonText:
             //   '<i class="fa fa-thumbs-up"></i> Great!',
             // confirmButtonAriaLabel: 'Thumbs up, great!',
              // cancelButtonText:
              //   '<i class="fa fa-thumbs-down"></i>',
             // cancelButtonAriaLabel: 'Thumbs down'
            })
          
        }

        const doDelete = (prom_id)=> {
            Swal.fire({
                title: 'Are you sure?',
                text: "Do you want delete this event?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
              }).then((result) => {
                if (result.isConfirmed) {
                    let galy_id=prom_id;
                    let params = { id : galy_id };
                    deleteEventGallery(params).then(res => handleDeleteRes(res,prom_id))
                }
              })
            
        }

        const handleDeleteRes = (response, prom_id) => {
            console.log(response);
            if(response.data.code==400){ //IF Token Expired......
                const errors = {};
                Swal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: response.data.message,
                })
              }else if(response.data.code==200){  //IF Request is Success
                let allEventData = list;
                let filteredArray =  allEventData.filter(item => item.id !== prom_id);
                setList(filteredArray);
                  Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Program Deleted Successfully',
                    showConfirmButton: false,
                    timer: 1500
                  })
              }
          }

return(
<section className="admin-section">
<div className="container">
<div className="row">
<div className="col-12">
<div className="card admin-table"> 
    <div className="card-header">
    <h1>Gallery Reviews</h1>
    <Link to="/creategalleryreview" className="add-event">+ Add New</Link>   
    </div>
    <div className="card-body">
    <div className="table-responsive">
        <table className="table">
            <thead>
                <tr>
                    <th>Title</th>
                    <th>Date</th>
                    <th>Author</th>
                    <th>Gallery Name</th>
                    <th>Review</th>
                    <th> </th>
                </tr>
            </thead>
            <tbody>

            { list.length ?
                    list.map( data => (
                        <tr key={data}>
                            <td>{data.title}</td>
                            <td>{data.date}</td>
                            <td>{data.author}</td>
                            <td>{data.gallery_name}</td>
                            <td className="admin-editdelete">
                            <Link to="#"><FontAwesomeIcon icon={faEye} onClick={()=> handleEyeClick(data.id)}    /></Link> &nbsp; / &nbsp;  
                            <Link to={"/editgalleryreview/"+data.id}><FontAwesomeIcon icon={faPenToSquare} /></Link></td>  
                            <td className="table-close">
                            <Link to="#"><FontAwesomeIcon icon={faXmark} onClick={()=> doDelete(data.id)}  /></Link>
                            </td>
                        </tr> 
                    )) :

                    <tr colSpan={6}> <p>No Record Found</p></tr>
                }
            </tbody>
        </table> 
    </div>
</div>
</div>
</div>
</div>
</div>  
</section>
)
}
